import { IMarketIntelligenceTagInput } from '@common/interfaces/marketIntelligence'
import { IApi } from '../../api'
import { createRequestTypes } from '../../helpers/helpers'
import { createAction } from '../types'

export const prefix = 'marketIntelligence'

export const [LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE] = createRequestTypes(prefix, 'LIST')

export const list = createAction((data: object = {}) => ({
  type: [LIST_REQUEST, LIST_SUCCESS, LIST_FAILURE],
  promise: (api: IApi) => api.marketIntelligence.list(data),
  params: data,
}))

export const [SHOW_REQUEST, SHOW_SUCCESS, SHOW_FAILURE] = createRequestTypes(prefix, 'SHOW')

/**
 * One item by id, for a `?id=` deep link. Read on its own rather than searched
 * for in the list, so the editor opens whatever the table is currently filtered
 * or paged to — the same reason the task panel calls myTasks.show.
 */
export const showItem = createAction((id: string) => ({
  type: [SHOW_REQUEST, SHOW_SUCCESS, SHOW_FAILURE],
  promise: (api: IApi) => api.marketIntelligence.show(id),
}))

export const [CREATE_REQUEST, CREATE_SUCCESS, CREATE_FAILURE] = createRequestTypes(prefix, 'CREATE')

export const create = createAction((data: object) => ({
  type: [CREATE_REQUEST, CREATE_SUCCESS, CREATE_FAILURE],
  promise: (api: IApi) => api.marketIntelligence.create(data),
}))

export const [UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE] = createRequestTypes(prefix, 'UPDATE')

export const update = createAction((id: string, data: object) => ({
  type: [UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE],
  promise: (api: IApi) => api.marketIntelligence.update(id, data),
}))

export const [DELETE_REQUEST, DELETE_SUCCESS, DELETE_FAILURE] = createRequestTypes(prefix, 'DELETE')

export const remove = createAction((id: string) => ({
  type: [DELETE_REQUEST, DELETE_SUCCESS, DELETE_FAILURE],
  promise: (api: IApi) => api.marketIntelligence.delete(id),
}))

export const [ADD_TAGS_REQUEST, ADD_TAGS_SUCCESS, ADD_TAGS_FAILURE] = createRequestTypes(
  prefix,
  'ADD_TAGS',
)

export const addTags = createAction((id: string, tags: IMarketIntelligenceTagInput[]) => ({
  type: [ADD_TAGS_REQUEST, ADD_TAGS_SUCCESS, ADD_TAGS_FAILURE],
  promise: (api: IApi) => api.marketIntelligence.addTags(id, tags),
}))

export const [RESOLVE_TAG_REQUEST, RESOLVE_TAG_SUCCESS, RESOLVE_TAG_FAILURE] = createRequestTypes(
  prefix,
  'RESOLVE_TAG',
)

export const resolveTag = createAction((id: string, target: IMarketIntelligenceTagInput) => ({
  type: [RESOLVE_TAG_REQUEST, RESOLVE_TAG_SUCCESS, RESOLVE_TAG_FAILURE],
  promise: (api: IApi) => api.marketIntelligence.resolveTag(id, target),
}))

export const [DELETE_TAG_REQUEST, DELETE_TAG_SUCCESS, DELETE_TAG_FAILURE] = createRequestTypes(
  prefix,
  'DELETE_TAG',
)

export const [CREATE_TAG_TARGET_REQUEST, CREATE_TAG_TARGET_SUCCESS, CREATE_TAG_TARGET_FAILURE] =
  createRequestTypes(prefix, 'CREATE_TAG_TARGET')

export const createTagTarget = createAction((data: { kind: string; name: string }) => ({
  type: [CREATE_TAG_TARGET_REQUEST, CREATE_TAG_TARGET_SUCCESS, CREATE_TAG_TARGET_FAILURE],
  promise: (api: IApi) => api.marketIntelligence.createTagTarget(data),
}))

export const deleteTag = createAction((id: string) => ({
  type: [DELETE_TAG_REQUEST, DELETE_TAG_SUCCESS, DELETE_TAG_FAILURE],
  promise: (api: IApi) => api.marketIntelligence.deleteTag(id),
}))
